import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import withWidth from '@material-ui/core/withWidth';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Collapse from '@material-ui/core/Collapse';
import RootRef from '@material-ui/core/RootRef';

import IconArrowHeadBottom from 'components/icons/IconArrowHeadBottom';
import IconButton from 'components/common/IconButton';

import isDescendant from 'utils/isDescendant';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

import {
  addRouterParamsSettingsSubmenu, removeRouterParamsSettingsSubmenu, collapseSettingsNavigation,
} from 'redux/modules/routerParams';

const styles = theme => ({
  listItemRoot: {
    padding: '13px 8px 16px 30px',
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.primary['500'],
    },
    '&:hover $iconButton': {
      color: theme.palette.primary['500'],
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  listItemSubmenu: {
    paddingLeft: 46,
    paddingTop: 10,
    paddingBottom: 10,
  },
  listItemRootActive: {
    color: theme.palette.secondary['800'],
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.primary['500'],
      backgroundColor: theme.palette.common.white,
    },
    '& $iconButton': {
      color: theme.palette.secondary['800'],
    },
    '&:hover $iconButton': {
      color: theme.palette.primary['500'],
    },
  },
  listItemTextRoot: {
    paddingLeft: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  listItemTextPrimary: {
    fontSize: pxToRem(14),
    fontWeight: 700,
    letterSpacing: pxToEm(0.7, 14),
    lineHeight: pxToEm(21, 14),
    color: 'inherit',   
  },
  listItemSubmenuTextPrimary: {
    fontSize: pxToRem(14),
    letterSpacing: pxToEm(0.7, 14),
    lineHeight: pxToEm(21, 14),
    color: 'inherit',
  },
  iconButton: {
    margin: '-16px -8px -16px 8px',
    color: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  iconArrowHeadBottom: {
    width: 14,
    height: 14,
  },
  iconArrowHeadBottomActive: {
    transform: 'rotate(180deg)',
  },
});

class NavigationItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subMenuOpen: props.subMenu && props.settingsSubmenu.indexOf(props.href) !== -1,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick() {
    const { actions, href } = this.props;
    if (this.state.subMenuOpen) {
      actions.removeRouterParamsSettingsSubmenu([href]);
    } else {
      actions.addRouterParamsSettingsSubmenu([href]);
    }
    this.setState({ subMenuOpen: !this.state.subMenuOpen });
  }

  render() {
    const {
      children, href, router, history, subMenu, icon, width, classes, actions,
    } = this.props;
    const { subMenuOpen } = this.state;
    const checkActiveRoute = () => {
      if (href === router.location.pathname) {
        return true;
      }
      if (href === '/settings/business'
          && router.location.pathname.indexOf('/settings/business') !== -1) {
        return true;
      }
      if (href === '/settings/users'
          && router.location.pathname.indexOf('/settings/users') !== -1) {
        return true;
      }
      if (href === '/settings/users'
          && router.location.pathname.indexOf('/settings/roles') !== -1) {
        return true;
      }
      if (href === '/settings/medical-sources'
          && router.location.pathname.indexOf('/settings/medical-sources') !== -1) {
        return true;
      }
      if (href === '/settings/data-portability'
          && router.location.pathname.indexOf('/settings/data-portability') !== -1) {
        return true;
      }
      if (href === '/settings/payment'
          && router.location.pathname.indexOf('/settings/payment') !== -1) {
        return true;
      }
      if (href === '/settings/templates'
          && router.location.pathname.indexOf('/settings/templates') !== -1) {
        return true;
      }
      if (href === '/settings/workspace'
          && router.location.pathname.indexOf('/settings/workspace') !== -1) {
        return true;
      }
      return false;
    };

    return (
      <Fragment>
        <ListItem
          button
          disableGutters
          classes={{
            root: classNames(classes.listItemRoot, {
              [classes.listItemRootActive]: checkActiveRoute() && (width === 'xs' || width === 'sm' || !subMenuOpen),
            }),
          }}
          onClick={(event) => {
            if (this.buttonRef) {
              if (!isDescendant(this.buttonRef, event.target)) {
                history.push(href);
              }
            } else {
              history.push(href);
            }
            setTimeout(() => {
              actions.collapseSettingsNavigation();
            }, 100);
          }}
        >
          <ListItemIcon>
            {icon}
          </ListItemIcon>
          <ListItemText
            primary={children}
            classes={{
              root: classes.listItemTextRoot,
              primary: classes.listItemTextPrimary,
            }}
          />
          {(width !== 'xs' && width !== 'sm' && subMenu) &&
            <RootRef
              rootRef={(buttonRef) => {
                this.buttonRef = buttonRef;
              }}
            >
              <IconButton
                className={classes.iconButton}
                onClick={this.onButtonClick}
              >
                {/* <IconPlus className={classes.iconPlus} /> */}

                <IconArrowHeadBottom
                  className={classNames(classes.iconArrowHeadBottom, {
                    [classes.iconArrowHeadBottomActive]: subMenuOpen,
                  })}
                />
              </IconButton>
            </RootRef>
          }
        </ListItem>
        {(width !== 'xs' && width !== 'sm' && subMenu) &&
          <Collapse in={subMenuOpen} timeout="auto" unmountOnExit>
            {subMenu.map(item => (
              <ListItem
                key={item.href}
                button
                disableGutters
                classes={{
                  root: classNames(classes.listItemRoot, classes.listItemSubmenu, {
                    [classes.listItemRootActive]: item.href === router.location.pathname,
                  }),
                }}
                onClick={() => {
                  history.push(item.href);
                }}
              >
                <ListItemText
                  primary={item.name}
                  classes={{
                    primary: classes.listItemSubmenuTextPrimary,
                  }}
                />
              </ListItem>
            ))}
          </Collapse>
        }
      </Fragment>
    );
  }
}

NavigationItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  subMenu: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string,
  })),
  settingsSubmenu: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.node.isRequired,
  actions: PropTypes.shape({
    addRouterParamsSettingsSubmenu: PropTypes.func.isRequired,
    removeRouterParamsSettingsSubmenu: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    listItemRoot: PropTypes.string.isRequired,
    listItemRootActive: PropTypes.string.isRequired,
    listItemTextPrimary: PropTypes.string.isRequired,
  }).isRequired,
};

NavigationItem.defaultProps = {
  subMenu: null,
  settingsSubmenu: [],
};

const mapStateToProps = store => ({
  router: store.router,
  settingsSubmenu: store.routerParams.settingsSubmenu,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    addRouterParamsSettingsSubmenu,
    removeRouterParamsSettingsSubmenu,
    collapseSettingsNavigation,
  }, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withWidth()(NavigationItem))),
);



// WEBPACK FOOTER //
// ./src/components/common/Layout/SettingsNavigation/SettingsNavigationItem.js